module.exports = __webpack_public_path__ + "img/star_min_gray.f462f917.png";